/*
  Sistema de Super Ofertas / Combos: producto principal + regalo gratis.

  Lee window.rtxComboProducts (inyectado por Liquid en theme.liquid con los
  combos activos relevantes a la pagina actual: el producto que se esta
  viendo + todo lo que ya haya en el carrito) y mantiene el carrito
  sincronizado:
    - Al agregar el producto principal -> agrega el regalo automaticamente
    - Al subir/bajar la cantidad del principal -> ajusta la cantidad del regalo
    - Al sacar el principal del carrito -> saca el regalo
    - Relabelea el descuento del regalo en el carrito como REGALO INCLUIDO

  La garantia de precio $0 en checkout la da la Shopify Function
  (product-discount), este script solo se encarga de la sincronizacion de
  UX. Si el JS falla por cualquier motivo, el regalo simplemente no se
  agrega/actualiza automaticamente, pero nunca se descuenta sin que la
  Function verifique que el producto principal este realmente en el carrito.
*/
(function () {
  'use strict';

  function getComboConfigs() {
    return window.rtxComboProducts || [];
  }

  async function getCart() {
    var res = await fetch('/cart.js');
    return res.json();
  }

  async function cartChange(lineKeyOrId, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKeyOrId, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  async function cartAdd(variantId, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity, properties: properties || {} }] })
    }).then(function (r) { return r.json(); });
  }

  function lineQtyForVariant(cart, variantId) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (String(item.variant_id) === String(variantId)) total += item.quantity;
    });
    return total;
  }

  function isGiftLine(item) {
    return item.properties && item.properties._rtx_combo_regalo === 'si';
  }

  async function syncGifts() {
    var configs = getComboConfigs();
    if (!configs.length) return;
    var cart = await getCart();
    var needsRefresh = false;

    for (var i = 0; i < configs.length; i++) {
      var combo = configs[i];
      var mainQty = lineQtyForVariant(cart, combo.mainVariantId);
      var expectedGiftQty = mainQty * (combo.giftsPerUnit || 1);

      var giftLine = cart.items.find(function (item) {
        return String(item.variant_id) === String(combo.giftVariantId) && isGiftLine(item);
      });
      var currentAutoGiftQty = giftLine ? giftLine.quantity : 0;

      if (expectedGiftQty > 0 && !giftLine) {
        await cartAdd(combo.giftVariantId, expectedGiftQty, { _rtx_combo_regalo: 'si', _rtx_combo_de: combo.mainProductTitle || '' });
        needsRefresh = true;
      } else if (expectedGiftQty > 0 && giftLine && currentAutoGiftQty !== expectedGiftQty) {
        await cartChange(giftLine.key, expectedGiftQty);
        needsRefresh = true;
      } else if (expectedGiftQty === 0 && giftLine) {
        await cartChange(giftLine.key, 0);
        needsRefresh = true;
      }
    }

    if (needsRefresh) {
      document.dispatchEvent(new CustomEvent('rtx:combo-cart-changed'));
      var cartDrawer = document.querySelector('cart-drawer, cart-notification');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        try {
          var freshCart = await getCart();
          cartDrawer.renderContents(freshCart);
        } catch (e) {}
      }
    }
  }

  function bindProductForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (form) {
      if (form.dataset.rtxComboBound) return;
      form.dataset.rtxComboBound = '1';
      form.addEventListener('submit', function () {
        setTimeout(syncGifts, 900);
      });
    });
  }

  function bindCartQuantityInputs() {
    document.addEventListener('change', function (e) {
      var target = e.target;
      if (target && (target.name === 'updates[]' || (target.classList && target.classList.contains('quantity__input')))) {
        setTimeout(syncGifts, 700);
      }
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('cart-remove-button, .cart-remove-button, [data-cart-remove]')) {
        setTimeout(syncGifts, 700);
      }
    });
  }

  function relabelGiftDiscounts() {
    document.querySelectorAll('.cart-item, .cart__row, [class*="cart-item"]').forEach(function (row) {
      var discountEls = row.querySelectorAll('.discount, [class*="discount"], .cart-item__discounted-prices, .cart-items__discount');
      discountEls.forEach(function (el) {
        if (el.textContent.indexOf('Regalo Combo') !== -1 && !el.dataset.rtxRelabeled) {
          el.dataset.rtxRelabeled = '1';
          el.innerHTML = el.innerHTML.replace('Regalo Combo Texalia', '\uD83C\uDF81 Regalo incluido').replace('Regalo Combo', '\uD83C\uDF81 Regalo incluido');
        }
      });
    });
  }

  function init() {
    bindProductForm();
    bindCartQuantityInputs();
    relabelGiftDiscounts();
    var observer = new MutationObserver(function () { relabelGiftDiscounts(); });
    observer.observe(document.body, { childList: true, subtree: true });
    syncGifts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
